module.exports = __webpack_public_path__ + "img/recommed-img6.96056b6e.jpg";